/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

// @ts-expect-error
import CommentBus from 'notebook/protocols/viewer/CommentBus';
import CommentForm from 'notebook/protocols/viewer/CommentForm';
import SingleComment from 'notebook/protocols/viewer/SingleComment';

type Comment = any;

interface Props {
  commentBus: CommentBus;
  comments: Array<Comment>;
  protocolID: string;
}

export default class Comments extends React.Component<Props> {
  render(): JSX.Element {
    let comment;
    const replies: {[itemId: string]: Array<Comment>} = {};
    const comments = _.sortBy(this.props.comments, 'created_at');
    const topLevelComments = [];
    for (comment of Array.from(comments)) {
      if (comment.type !== 'comment') {
        topLevelComments.push(comment);
        continue;
      }
      if (replies[comment.item_id] == null) {
        replies[comment.item_id] = [];
      }
      replies[comment.item_id].push(comment);
    }
    return (
      <div className="row">
        <div className="protocol-comments">
          {(() => {
            const result = [];
            for (comment of Array.from(topLevelComments)) {
              result.push(
                <SingleComment
                  // eslint-disable-next-line no-restricted-syntax
                  {..._.extend({}, comment, {
                    key: comment.id,
                    children: replies[comment.id] || [],
                    commentBus: this.props.commentBus,
                    showContext: true,
                  })}
                />
              );
            }
            return result;
          })()}
          {this.props.commentBus.canComment ? (
            <CommentForm
              linkableID={this.props.protocolID}
              //  TODO(eln): this should be protocol_version
              linkType="protocol"
              onDescription={false}
              commentBus={this.props.commentBus}
              shouldFocus={false}
            />
          ) : undefined}
        </div>
      </div>
    );
  }
}
